// extracted by mini-css-extract-plugin
export default {"container":"nc_PTu"};